import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config/apiClientConfig';

export const dependentSchema = z.object({
	maritalStatusId: z.number(),
	relationshipTypeId: z.number(),
	dateOfBirth: z.string(),
	nationalityId: z.number(),
	genderId: z.number(),
	salaryBandId: z.number().optional(),
});

export const principalDetailsSchema = z.object({
	maritalStatusId: z.number(),
	genderId: z.number(),
	dateOfBirth: z.string(),
	nationalityId: z.number(),
	salaryBandId: z.number().optional(),
});

export const requestSchema = z.object({
	policyTypeId: z.number(),
	quotePlanCategoryId: z.number().optional(),
	emirateId: z.number(),
	channelTypeId: z.number(),
	principalDetails: principalDetailsSchema,
	dependents: z.array(dependentSchema).optional(),
});

export const memberIdSchema = z.object({
	memberId: z.string(),
});

export const responseSchema = z.object({
	encryptedJourneyId: z.string(),
});

const postCreateJourney = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Member/createJourney',
		method: 'POST',
		responseSchema: responseSchema,
		requestSchema: requestSchema,
		errorCodes: ['MaxNumberOfMembers'],
	});

export type CreateJourneyRequest = z.infer<typeof requestSchema> & {
	policyType: number;
};

export type CreateJourneyResponse = TypeOfAPIResponse<ReturnType<typeof postCreateJourney>>;

export type CreateJourneyError = TypeOfAPIError<ReturnType<typeof postCreateJourney>>;

export default postCreateJourney;
